import { Toast } from "../../../../components/Common/Toast";
import { callAPI } from "../../../../services/api.service";

export interface ErrorLogsFilters {
    bookId?: string | null;
    errorCode?: string | null;
    errorProvider?: string | null;
    errorSource?: string | null;
    module?: string | null;
    severity?: string | null;
}

export const fetchErrorLogs = async (currentPage: number, filters: ErrorLogsFilters = {}) => {
    try {
        let url = `api/error-log/getAllErrors?pageNumber=${currentPage}`;
        if (filters.bookId) url += `&bookId=${encodeURIComponent(filters.bookId)}`;
        if (filters.errorCode) url += `&errorCode=${encodeURIComponent(filters.errorCode)}`;
        if (filters.errorProvider) url += `&errorProvider=${encodeURIComponent(filters.errorProvider)}`;
        if (filters.errorSource) url += `&errorSource=${encodeURIComponent(filters.errorSource)}`;
        if (filters.module) url += `&module=${encodeURIComponent(filters.module)}`;
        if (filters.severity) url += `&severity=${encodeURIComponent(filters.severity)}`;
        const response = await callAPI(url);
        return {
            errorLogs: response?.errorLogs || [],
            totalPages: response?.totalPages || 0,
        };
    } catch (error) {
        Toast("Something went wrong!", true);
        throw error;
    }
};

export const searchErrorLogs = async (searchTerm: string) => {
    try {
        const response = await callAPI(`api/error-log/error-search?searchTerm=${searchTerm}`);
        return response?.message || [];
    } catch (error) {
        Toast("Error searching error logs", true);
        throw error;
    }
};